import { render } from "./KnowledgeZone.vue?vue&type=template&id=eb148efa"
import script from "./KnowledgeZone.vue?vue&type=script&lang=js"
export * from "./KnowledgeZone.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__